import React, {FC, useContext} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';

import Typography from '@mui/material/Box';
import Box from '@mui/material/Box';

import {RootReducer} from 'appRedux/reducers';

import {PermissionContext} from 'contexts/permission/context';

import AttachedAgentsList from 'pages/admin/updateResourceField/calendar/notifications/AttachedAgentsList';
import AttachedGroupsList from 'pages/admin/updateResourceField/calendar/notifications/AttachedGroupsList';
import AttachAgentButton from 'pages/admin/updateResourceField/calendar/notifications/AttachAgentButton';
import AttachGroupButton from 'pages/admin/updateResourceField/calendar/notifications/AttachGroupButton';

const CalendarNotifications: FC = () => {
    const [t] = useTranslation();

    const {isOrganizationEditEnabled, isRoleEditEnabled} = useContext(PermissionContext);

    const {
        resourceFields: {currentCalendarItem},
    } = useSelector<RootReducer>((state: RootReducer) => state) as RootReducer;

    const {agents, groups} = currentCalendarItem;

    return (
        <Box>
            <Typography sx={{mb: 2, fontWeight: 700}}>{`${t('orguser.resourceFields.notifications')}:`}</Typography>
            <Box>
                {agents && agents.length > 0 && <AttachedAgentsList items={agents} />}
                <AttachAgentButton currentCalendar={currentCalendarItem} />
                {isOrganizationEditEnabled && isRoleEditEnabled && (
                    <>
                        {groups && groups.length > 0 && <AttachedGroupsList items={groups} />}
                        <AttachGroupButton currentCalendar={currentCalendarItem} />
                    </>
                )}
            </Box>
        </Box>
    );
};

export default CalendarNotifications;
